import { Controller } from 'react-hook-form'
import styled from 'styled-components'

const StyledController = styled(Controller)`
  
`

export default StyledController
